import React from 'react';
import ComposeWithTemplate from './ComposeWithTemplate';

const UpdateMessageStep: React.FC = () => (
  <ComposeWithTemplate intent="update" />
);

export default UpdateMessageStep;
